module.exports = __webpack_public_path__ + "static/media/cart.18b8469d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/cart.png
// module id = 195
// module chunks = 0